import { increment } from '@zocdoc-frontend-common/utils-react';

/**
 * @description sets session storage data for the given key
 * @param {string} key
 * @param {string} value
 * @returns {boolean}
 */
export function setSessionStorageItem(key, value) {
    if (typeof window === 'undefined') {
        throw new Error(
            'Session Storage can only be used during client-side rendering'
        );
    }

    try {
        window.sessionStorage.setItem(key, value);
        return true;
    } catch (err) {
        increment({
            name: 'frontend_common.session_storage.error',
            tags: ['set'],
        });
        return false;
    }
}

/**
 * @description removes session storage data for the given key
 * @param {string} key
 * @returns {boolean}
 */
export function removeSessionStorageItem(key) {
    if (typeof window === 'undefined') {
        throw new Error(
            'Session Storage can only be used during client-side rendering'
        );
    }

    try {
        window.sessionStorage.removeItem(key);
        return true;
    } catch (err) {
        increment({
            name: 'frontend_common.session_storage.error',
            tags: ['remove'],
        });
        return false;
    }
}

/**
 * @description fetches storage data for the given key
 * @param {string} key
 * @returns {string|null}
 */
export function getSessionStorageItem(key) {
    if (typeof window === 'undefined') {
        throw new Error(
            'Session Storage can only be used during client-side rendering'
        );
    }

    try {
        return window.sessionStorage.getItem(key) || null;
    } catch (err) {
        increment({
            name: 'frontend_common.session_storage.error',
            tags: ['get'],
        });

        return null;
    }
}
